import { atom } from "recoil";
import { ICategoryData, useXoraiaValue } from "./useXoraia";
import useSWR from "swr";

export const USE_CATEGORIES = atom<ICategoryData[]>({
  key: "USE_CATEGORIES",
  default: [],
});

export const useCategories = (articleId?: string) => {
  const { apiFetcher, businessId } = useXoraiaValue();
  const requestKey = `useCategories${articleId ? "-" + articleId : ""}`;

  const { data } = useSWR(
    requestKey,
    async () => {
      try {
        if (!apiFetcher || !apiFetcher.categories) {
          throw "no-api-fetcher";
        }

        const _opts = await apiFetcher.categories({ businessId, articleId });

        return _opts ?? [];
      } catch (error) {
        console.error("useCategories/Error =>", error);

        return [];
      }
    },
    { fallbackData: [] }
  );

  console.log("useCategories/Data =>", data);

  return { categories: data };

  // const { apiFetcher, businessId } = useXoraiaValue();
  // const [categories, setCategories] = useRecoilState(USE_CATEGORIES);

  // React.useEffect(() => {
  //   const getCategories = async () => {
  //     if (!apiFetcher || !apiFetcher.categories || categories.length !== 0)
  //       return;

  //     try {
  //       const _cate = await apiFetcher.categories({ businessId });

  //       if (_cate.length > 0) setCategories(_cate);
  //     } catch (error) {
  //       console.error("GET OPT =>", error);
  //     }
  //   };

  //   getCategories();
  // }, [apiFetcher, categories]);

  // return { categories, setCategories };
};
